import { Div } from '@icecreamsocial/components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useCampaign } from '../../../../../../../../../utils/hooks/useCampaign';
import {
	EditFormControls,
	Pagename,
	PolicySettingsForm,
} from '../../../../../../../../presentational';

const PolicySettings = () => {
	const { campaignId } = useParams();
	const { campaign, update } = useCampaign({ campaignId });
	const { data } = campaign;
	const initialValues = {
		maskInfo: data?.maskInfo,
		termsAndConditionsURL: data?.termsAndConditionsURL,
		privacyPolicyURL: data?.privacyPolicyURL,
		useEmailConsent: data?.useEmailConsent,
		useSMSConsent: data?.useSMSConsent,
	};

	const onSubmit = ({
		maskInfo,
		termsAndConditionsURL,
		privacyPolicyURL,
		useEmailConsent,
		useSMSConsent,
	}) => {
		update.mutate({
			maskInfo,
			termsAndConditionsURL: termsAndConditionsURL,
			privacyPolicyURL: privacyPolicyURL,
			useEmailConsent,
			useSMSConsent,
		});
	};

	return (
		<Div>
			<Pagename>Data & Policy Settings</Pagename>
			{data && (
				<PolicySettingsForm
					onSubmit={onSubmit}
					renderControls={(props) => <EditFormControls {...props} />}
					{...initialValues}
				/>
			)}
		</Div>
	);
};
PolicySettings.displayName = 'Campaigns.Campaign.Settings.Policy';

export default observer(PolicySettings);
